import api from './api';

const GUEST_TOKEN_KEY = 'support_guest_token';

export const getSupportGuestToken = () => localStorage.getItem(GUEST_TOKEN_KEY);

export const setSupportGuestToken = (token) => {
  if (token) {
    localStorage.setItem(GUEST_TOKEN_KEY, token);
  }
};

const guestHeaders = () => {
  const token = getSupportGuestToken();
  return token ? { 'X-Support-Guest-Token': token } : {};
};

const visitorConfig = (authContext) => ({
  headers: guestHeaders(),
  ...(authContext ? { _authContext: authContext } : {}),
});

export const getVisitorSupportConversation = async (authContext, storeId) => {
  const response = await api.get('/support-chat/conversation', {
    ...visitorConfig(authContext),
    params: storeId ? { storeId } : undefined,
  });
  return response.data;
};

export const sendVisitorSupportMessage = async (payload, authContext) => {
  const response = await api.post(
    '/support-chat/messages',
    payload,
    visitorConfig(authContext),
  );
  if (response.data?.guestToken) {
    setSupportGuestToken(response.data.guestToken);
  }
  return response.data;
};

export const getSupportConversations = async () => {
  const response = await api.get('/support-chat/conversations', { _authContext: 'management' });
  return response.data || [];
};

export const getSupportWaitingCount = async () => {
  const response = await api.get('/support-chat/conversations/waiting-count', { _authContext: 'management' });
  return response.data ?? 0;
};

export const getSupportConversation = async (conversationId) => {
  const response = await api.get(`/support-chat/conversations/${conversationId}`, { _authContext: 'management' });
  return response.data;
};

export const sendAdminSupportMessage = async (conversationId, body) => {
  const response = await api.post(
    `/support-chat/conversations/${conversationId}/messages`,
    { body },
    { _authContext: 'management' },
  );
  return response.data;
};

export const closeSupportConversation = async (conversationId) => {
  await api.post(`/support-chat/conversations/${conversationId}/close`, null, { _authContext: 'management' });
};
